export default function SectionTitle({ overline, highlight, align = "left", textColor = '', showLogo = false, separatorColor = 'black' }) {
  const isWhite = textColor === "text-white";
  const isCentered = align === "center";

  return (
    <div className={`mt-2 mb-10 ${isCentered ? "text-center items-center" : "text-left"}`}>
      {/* Conteneur interne pour l'alignement */}
      <div className="max-w-5xl">
        {overline && (
          <div className={`flex items-center ${isCentered ? "justify-center" : ""} mb-1`}>
            {showLogo && (
              <img
                src="/favicon.png"
                alt="Logo Socabeg"
                className="h-5 w-auto object-contain mr-2"
              />
            )}
            <span className={`uppercase ${isWhite ? "text-white" : "text-socabeg-dark-gray"} text-base font-semibold tracking-widest`}>
              {typeof overline === 'string' ? overline : ''}
            </span>
          </div>
        )}
        
        <div className={`h-1 w-6 ${separatorColor === 'socabeg-red' ? 'bg-socabeg-red' : separatorColor === 'socabeg-blue' ? 'bg-socabeg-blue' : 'bg-socabeg-blue'} ${isCentered ? "mx-auto" : ""} mb-1`}></div>
        
        {highlight && highlight.trim() !== '' && (
          <div className={`${isCentered ? "flex justify-center" : ""} mb-0`}>
            <h2 className={`uppercase text-xl md:text-2xl lg:text-3xl xl:text-4xl font-bold ${isWhite ? 'text-white' : 'text-socabeg-dark-gray'} leading-tight`}>
              {highlight.replace(/\n/g, ' ')}
            </h2>
          </div>
        )}
      </div>
    </div>
  );
}